//export const API_BASE_URL = 'http://localhost:8080/api';

//container
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;